module.exports = __webpack_public_path__ + "static/img/WechatIMG40.3fe2911.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/WechatIMG40.jpeg
// module id = 313
// module chunks = 1